import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { isNull } from '@polkadot/util';
/**
 * @name Null
 * @description
 * Implements a type that does not contain anything (apart from `null`)
 */

export var Null = /*#__PURE__*/function () {
  // Added for compatibility reasons, e.g. see Option
  function Null(registry) {
    _classCallCheck(this, Null);

    _defineProperty(this, "initialU8aLength", 0);

    this.registry = registry;
  }
  /**
   * @description The length of the value when encoded as a Uint8Array
   */


  _createClass(Null, [{
    key: "encodedLength",
    get: function get() {
      return 0;
    }
    /**
     * @description returns a hash of the contents
     */

  }, {
    key: "hash",
    get: function get() {
      throw new Error('.hash is not implemented on Null');
    }
    /**
     * @description Checks if the value is an empty value (always true)
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return true;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */

  }, {
    key: "eq",
    value: function eq(other) {
      return other instanceof Null || isNull(other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */

  }, {
    key: "inspect",
    value: function inspect() {
      return {};
    }
    /**
     * @description Returns a hex string representation of the value
     */

  }, {
    key: "toHex",
    value: function toHex() {
      return '0x';
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */

  }, {
    key: "toHuman",
    value: function toHuman() {
      return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return null;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return 'Null';
    }
    /**
     * @description Returns the string representation of the value
     */

  }, {
    key: "toString",
    value: function toString() {
      return '';
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "toU8a",
    value: function toU8a(isBare) {
      return new Uint8Array();
    }
  }]);

  return Null;
}();